import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sprite } from '@agissc/ktag-map';
import classNames from 'classnames';

interface ChipOptionProps {
  key: string;
  value: string;
  tooltip?: string;
}

interface MultiSelectChipsProps {
  options: ChipOptionProps[];
  selectedOptions: string[];
  disabled?: boolean;
  onClick: (item: string) => void;
}

interface ChipButtonProps {
  label: string;
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
  tooltip?: string;
}

const ChipButton = ({
  label,
  isSelected,
  onClick,
  disabled = false,
  tooltip,
}: ChipButtonProps) => {
  return (
    <Button
      title={tooltip}
      disabled={disabled}
      onClick={onClick}
      additionalClassNames={classNames('multiselect-chips__button', {
        'multiselect-chips__button--selected': isSelected,
        'multiselect-chips__button--disabled': disabled,
      })}
    >
      {isSelected && (
        <Sprite id="checkmark" additionalClassNames="multiselect-chips__button-icon" />
      )}
      {label}
    </Button>
  );
};

const MultiSelectChips = ({
  options,
  selectedOptions,
  onClick,
  disabled = false,
}: MultiSelectChipsProps) => {
  const { t } = useTranslation('agisviewer');
  return (
    <div className="multiselect-chips">
      {options.map((option) => (
        <ChipButton
          key={option.key}
          tooltip={option.tooltip === undefined ? t(option.value) : t(option.tooltip)}
          label={t(option.value)}
          disabled={disabled}
          isSelected={selectedOptions.includes(option.key)}
          onClick={() => onClick(option.key)}
        />
      ))}
    </div>
  );
};

export default MultiSelectChips;
